import type { SVGProps } from "react";
import { BRAND_SHADES } from "../providers/themev2/colors";

const MONOGRAM_PATH =
  "M141 340C39.5 340 7.07805e-07 286.5 7.07805e-07 207.5V192H57V208C57 263 75.5 288 141 288C206.5 288 226 263.5 226 210.5V-8.34465e-06H282.5V210C282.5 287 243.5 340 141 340Z";

const WORDMARK_PATH =
  "M141 340C39.5 340 7.07805e-07 286.5 7.07805e-07 207.5V192H57V208C57 263 75.5 288 141 288C206.5 288 226 263.5 226 210.5V-8.34465e-06H282.5V210C282.5 287 243.5 340 141 340ZM418.43 340C366.93 340 334.43 316 334.43 275C334.43 236.5 365.43 216.5 414.43 211L527.43 199V184.5C527.43 143.5 509.43 129 461.93 129C415.93 129 393.43 144 393.43 180.5V182.5H339.93V180.5C339.93 124 386.93 81.5 465.93 81.5C544.93 81.5 580.43 124.5 580.43 184V335H530.93V273H527.43C514.43 315 474.93 340 418.43 340ZM388.43 271.5C388.43 291.5 401.93 301 432.93 301C489.43 301 527.43 280 527.43 231L429.93 242C401.93 245.5 388.43 252 388.43 271.5ZM761.133 340C681.133 340 635.633 308.5 635.633 251V249.5H689.633V253.5C689.633 286 709.133 296.5 761.133 296.5C809.633 296.5 824.133 286.5 824.133 264.5C824.133 244 812.133 237.5 776.633 232.5L708.633 223.5C661.633 217.5 633.133 197.5 633.133 156C633.133 112.5 672.633 81.5 749.133 81.5C825.133 81.5 871.133 112 871.133 171V172.5H817.633V169.5C817.633 140 802.633 124.5 747.633 124.5C702.133 124.5 686.133 134.5 686.133 158C686.133 177.5 696.133 184.5 733.633 189.5L791.133 197.5C850.133 205 877.133 225 877.133 266C877.133 312.5 831.133 340 761.133 340ZM985.094 420H931.094V86.5H980.594V155.5H985.094C995.094 109.5 1030.09 81.5 1088.59 81.5C1165.59 81.5 1209.09 134 1209.09 211C1209.09 288 1166.59 340 1089.09 340C1033.09 340 997.094 310.5 987.094 265H985.094V420ZM985.094 215C985.094 266 1017.59 291 1070.59 291C1124.09 291 1155.09 270.5 1155.09 211C1155.09 151 1123.59 131 1071.59 131C1016.09 131 985.094 157 985.094 210.5V215ZM1386.52 340C1305.02 340 1251.52 294 1251.52 211C1251.52 133.5 1304.52 81.5 1385.52 81.5C1462.52 81.5 1515.02 124 1515.02 199.5C1515.02 208.5 1514.52 215.5 1513.02 223H1302.02C1304.02 271 1327.52 296.5 1385.02 296.5C1437.02 296.5 1458.52 279.5 1458.52 250V246H1512.52V250.5C1512.52 303.5 1460.52 340 1386.52 340ZM1384.52 124C1329.52 124 1305.52 148.5 1302.52 193H1464.02V192C1464.02 146 1437.52 124 1384.52 124ZM1624.47 335H1570.47V86.5H1619.97V153.5H1623.47C1630.97 113.5 1657.97 81.5 1708.97 81.5C1765.47 81.5 1789.97 122 1789.97 169V201.5H1736.47V179.5C1736.47 144 1721.47 127.5 1684.47 127.5C1641.97 127.5 1624.47 151 1624.47 195.5V335Z";

const WORDMARK_RATIO = 1790 / 420;

export type JasperMonogramProps = Omit<SVGProps<SVGSVGElement>, "color"> & {
  size?: number | string;
};

export type JasperWordmarkVariant = "brand" | "white";

export type JasperWordmarkProps = JasperMonogramProps & {
  variant?: JasperWordmarkVariant;
};

export function JasperMonogram({ size = 40, ...props }: JasperMonogramProps) {
  return (
    <svg
      viewBox="0 0 96 96"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Jasper"
      {...props}
    >
      <rect width="96" height="96" rx="12" fill={BRAND_SHADES[500]} />
      <svg
        x="21.12"
        y="21.12"
        width="53.76"
        height="53.76"
        viewBox="0 0 282 340"
      >
        <path d={MONOGRAM_PATH} fill="#FFFFFF" />
      </svg>
    </svg>
  );
}

export function JasperWordmark({
  size = 32,
  variant = "brand",
  ...props
}: JasperWordmarkProps) {
  const height = typeof size === "number" ? size : undefined;

  return (
    <svg
      viewBox="0 0 1790 420"
      height={size}
      width={height ? height * WORDMARK_RATIO : undefined}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Jasper"
      {...props}
    >
      <path
        d={WORDMARK_PATH}
        fill={variant === "white" ? "#FFFFFF" : BRAND_SHADES[500]}
      />
    </svg>
  );
}
